import { render, staticRenderFns } from "./affiliation.vue?vue&type=template&id=00cfda28&scoped=true&lang=html"
import script from "./affiliation.vue?vue&type=script&lang=js"
export * from "./affiliation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cfda28",
  null
  
)

/* custom blocks */
import block0 from "./affiliation.vue?vue&type=custom&index=0&blockType=section&v-if=value.affiliations"
if (typeof block0 === 'function') block0(component)

export default component.exports